export default __webpack_public_path__ + "static/media/pencil-icon.a5842509.svg";